import { urlSafeBase64 } from '../urlSafeBase64';

export type ImgproxyImageProps = {
  src: string;
  width: number;
  quality: number;
  ratio?: number;
  gravity?: string;
  enlarge?: boolean;
  absolute?: boolean;
};

const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
const DEBUG_RESPONSIVE_IMAGES = process.env.NEXT_PUBLIC_DEBUG_RESPONSIVE_IMAGES === 'true';
const PRODUCTION = process.env.NODE_ENV === 'production';

export const generateImagePath = ({
  src,
  width,
  quality,
  ratio,
  enlarge = false,
  absolute = false,
}: ImgproxyImageProps) => {

  if (DEBUG_RESPONSIVE_IMAGES) {
    return `https://fakeimg.pl/${width}x${Math.round(width * 0.5625)}/bbb/ffffff?text=${width}`;
  }

  if (!PRODUCTION) return src;

  const encodedURL = urlSafeBase64(src);
  const params = new URLSearchParams();

  let path = '';

  params.append('width', width.toString());

  if (enlarge) {
    params.append('enlarge', '1');
  }

  if (ratio) {
    params.append('ratio', ratio.toString());
  }

  if (absolute && BASE_URL) {
    let baseUrl = BASE_URL;

    if (baseUrl.slice(-1) === '/') {
      baseUrl = baseUrl.slice(0, -1);
    }

    path = baseUrl;
  }

  path += `/api/image/${encodedURL}?${params.toString()}`;

  return path;
};

const imgproxyLoaderFactory = () => generateImagePath;

export default imgproxyLoaderFactory;
